import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import {ArrowBtn} from "../../../app-constants";


function Servicelisting(props) {
    return (
        <section className="p-100 pt-0">
            <Container>
                <>
                    <Row>
                        <Col xs={12} md={12} lg={12} xl={12} xxl={12}
                             className="seriveces_listing page_listing">
                            <div className="example" data-text="Languages">
                                <h2>Languages</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>

                        <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                            <div className="item_listing">
                                <h4>.Net</h4>
                                <p>TekRevol uses the .NET platform to build state-of-the-art software systems. We build
                                    technologies using .NET that help you in every walk of life.</p>
                                <Link to="/dot-net-development">
                                    {ArrowBtn}
                                </Link>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                            <div className="item_listing">
                                <h4>HTML5</h4>
                                <p>We help businesses build robust digital solutions for internal operational and
                                    diverse customer segments, including web, apps, and SaaS.</p>
                                <Link to="/html5-development">
                                    {ArrowBtn}
                                </Link>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                            <div className="item_listing">
                                <h4>Java</h4>
                                <p>Our native app development solutions for Android have enabled many of our clients to
                                    achieve their targets and see unprecedented business growth.</p>
                                <Link to="/java-development">
                                    {ArrowBtn}
                                </Link>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                            <div className="item_listing">
                                <h4>Node.js</h4>
                                <p>Get an interactive web app or a data-intensive program with a robust backend with
                                    TekRevol’s Node.js developers.</p>
                                <Link to="/hire-nodejs-developers">
                                    {ArrowBtn}
                                </Link>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                            <div className="item_listing">
                                <h4>PHP</h4>
                                <p>TekRevol is a PHP development company encompassing all the solutions you may require
                                    while developing a backend solution for your business</p>
                                <Link to="/php-development">
                                    {ArrowBtn}
                                </Link>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                            <div className="item_listing">
                                <h4>Python</h4>
                                <p>We are a python development company using Python for web development, CMS portals,
                                    machine learning.</p>
                                <Link to="/python-development">
                                    {ArrowBtn}
                                </Link>
                            </div>
                        </Col>

                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} xl={12} xxl={12}
                             className="seriveces_listing page_listing">
                            <div className="example" data-text="Platforms">
                                <h2>Platforms</h2>
                            </div>
                        </Col>

                        <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                            <div className="item_listing">
                                <h4>Azure</h4>
                                <p>TekRevol helps you create and deliver innovative business experiences to your
                                    stakeholders on a secure, robust Microsoft Azure cloud infrastructure.</p>
                                <Link to="/azure-consultant">
                                    {ArrowBtn}
                                </Link>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                            <div className="item_listing">
                                <h4>GCP</h4>
                                <p>TekRevol helps its clients migrate, modernize and transform their data with GCP
                                    Cloud, the Google Cloud Platform service</p>
                                <Link to="/gcp-cloud">
                                    {ArrowBtn}
                                </Link>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                            <div className="item_listing">
                                <h4>Oracle</h4>
                                <p>Our Oracle consulting services enable businesses to build and manage cloud
                                    applications with the right tools</p>
                                <Link to="/oracle-solution">
                                    {ArrowBtn}
                                </Link>
                            </div>
                        </Col>
                        <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                            <div className="item_listing">
                                <h4>SAP</h4>
                                <p>For clients from diverse industries, our SAP consultants have helped them achieve a
                                    stable organizational structure</p>
                                <Link to="/sap-consultant">
                                    {ArrowBtn}
                                </Link>
                            </div>
                        </Col>
                    </Row>
                </>
            </Container>
        </section>
    );
}

export default Servicelisting;